<template>
  <form class="nx-form" :data-vv-scope="scope" :id="'scope-' + scope" :class="{'nx-active' :active}">
    <h2 v-if="scope" class="nx-form-legend">{{ $t('message.form.scopes.' + scope) }}</h2>
    <div class="nx-form-fieldset">
      <nx-relation-form
        label="Twitter"
        name="relationTwitter"
        :limit="1"
        :value="draft.relationTwitter"
        :disabled="disabled"
        :card-params="cardParams"
        @bcube-assistant="$emit('bcube-assistant', $event)"
      ></nx-relation-form>

      <nx-relation-form
        label="Facebook OG"
        name="relationOg"
        :limit="1"
        :value="draft.relationOg"
        :disabled="disabled"
        :card-params="cardParams"
        @bcube-assistant="$emit('bcube-assistant', $event)"
      ></nx-relation-form>
    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import RelationForm from '@/modules/relation/Form';
import { aspectRatios } from '../../../clipping/config';

export default {
  name: 'nx-form-content-customizations',
  extends: FormScope,
  components: {
    [RelationForm.name]: RelationForm,
  },
  computed: {
    cardParams() {
      return {
        aspectRatios: [
          aspectRatios['16-9-aspect-ratio'].alias,
        ],
      };
    },
  },
};
</script>
